/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { dataRemovalRequestApprove } from '../../axios/dataRemovalRequestApprove'
import type {
	DataRemovalRequestApproveError,
	DataRemovalRequestApprovePathParams,
	DataRemovalRequestApproveResponse,
} from '../../types/DataRemovalRequestApprove'

export const dataRemovalRequestApproveMutationKey = () =>
	[{ url: '/organisations/:organisation/data-removal-requests/:dataRemovalRequest/approve' }] as const

export type DataRemovalRequestApproveMutationKey = ReturnType<typeof dataRemovalRequestApproveMutationKey>

export type DataRemovalRequestApproveVariables = {
	organisation: DataRemovalRequestApprovePathParams['organisation']
	dataRemovalRequest: DataRemovalRequestApprovePathParams['dataRemovalRequest']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/DataRemovalRequestController.php DataRemovalRequestController::approve */
export function useDataRemovalRequestApprove<TContext = unknown>(
	options?: UseMutationOptions<
		DataRemovalRequestApproveResponse,
		AxiosError<DataRemovalRequestApproveError>,
		DataRemovalRequestApproveVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: dataRemovalRequestApproveMutationKey(),
		mutationFn: ({ organisation, dataRemovalRequest }: DataRemovalRequestApproveVariables) =>
			dataRemovalRequestApprove(organisation, dataRemovalRequest, config).then(res => res.data),
		...options,
	})
}
